import { z } from 'zod'

export default z.object({
  __typename: z.literal('Storage').default('Storage'),
  id: z.number(),
})
